export class SitePages {
    // Main pages
    static FrontPage = "";
    
    // Contribution Pages
    static MicrobialSexLoops = "paths-through-the-microbial-sex-loops"    
    static MicrobialSexVideoComic = "microbial-sex-video-comic";
    static CybershoreMeditations = "cybershore-meditations";
    static DecaySim = "decay-sim";

    // Dev pages
    static NavigationPage = "nav";
    static MobilePopup = "mobile-redirect";
    
    // Home Page reference
    static Home =  SitePages.FrontPage
}

export class PageTitles {
    
    static default = "Symbiosis | Organism";
    static Error = "Error | Symbiosis | Organism";
    
    static MicrobialSexLoops = "Microbial Sex Loops | Symbiosis"
    static MicrobialSexVideoComic = "Microbial Sex Video Comic | Symbiosis"
    static CybershoreMeditations = "Cybershore Meditations | Symbiosis"
    static DecaySim = "Decay Sim | Symbiosis"
}